package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import io.ktor.client.call.body
import io.ktor.client.statement.bodyAsText
import kotlinx.serialization.Serializable

@Serializable
data class UploadImageResponse(val url: String)

class UploadRepository(
    private val api: ApiClient,
    private val sessionManager: SessionManager
) {
    suspend fun uploadGameImage(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.postMultipart(
                endpoint = "uploads/game-image",
                bytes = bytes,
                fileName = fileName,
                mimeType = mimeType
            )

            if (response.status.value !in 200..299) {
                return Result.failure(Exception(response.bodyAsText()))
            }

            val parsed: UploadImageResponse = response.body()
            Result.success(parsed.url)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun uploadPlayerImage(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.postMultipart(
                endpoint = "uploads/player-image",
                bytes = bytes,
                fileName = fileName,
                mimeType = mimeType
            )

            if (response.status.value !in 200..299) {
                return Result.failure(Exception(response.bodyAsText()))
            }

            val parsed: UploadImageResponse = response.body()
            Result.success(parsed.url)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun uploadExpansionImage(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.postMultipart(
                endpoint = "uploads/expansion-image",
                bytes = bytes,
                fileName = fileName,
                mimeType = mimeType
            )

            if (response.status.value !in 200..299) {
                return Result.failure(Exception(response.bodyAsText()))
            }

            val parsed: UploadImageResponse = response.body()
            Result.success(parsed.url)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun uploadClanImage(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.postMultipart(
                endpoint = "uploads/clan-image",
                bytes = bytes,
                fileName = fileName,
                mimeType = mimeType
            )

            if (response.status.value !in 200..299) {
                return Result.failure(Exception(response.bodyAsText()))
            }

            val parsed: UploadImageResponse = response.body()
            Result.success(parsed.url)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun uploadUserImage(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.postMultipart(
                endpoint = "uploads/user-image",
                bytes = bytes,
                fileName = fileName,
                mimeType = mimeType
            )

            if (response.status.value !in 200..299) {
                return Result.failure(Exception(response.bodyAsText()))
            }

            val parsed: UploadImageResponse = response.body()
            Result.success(parsed.url)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
